export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/filterWorker.9593d796.worker.js");
}
